import React, { useState, useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import {
  Close as CloseIcon,
  AudioFile as AudioIcon,
  Description as DocumentIcon,
} from "@mui/icons-material";

const FilePreviewItem = React.memo(({ file, index, onRemoveFile, getFileType }) => {
  const [objectUrl, setObjectUrl] = useState(null);
  const fileType = getFileType(file);

  useEffect(() => {
    // Only create object URLs for images and videos
    if (fileType === "image" || fileType === "video") {
      const url = URL.createObjectURL(file);
      setObjectUrl(url);
      
      // Revoke URL on cleanup to prevent memory leaks
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [file, fileType]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          height: { xs: "100px", sm: "120px" },
          borderRadius: 1,
          overflow: "hidden",
          border: "2px solid #E5E7EB",
          position: "relative",
          backgroundColor: "#F9FAFB",
        }}
      >
        {fileType === "image" ? (
          objectUrl && (
            <img
              src={objectUrl}
              alt={file.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )
        ) : fileType === "video" ? (
          objectUrl && (
            <video
              src={objectUrl}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              muted
              preload="metadata"
            />
          )
        ) : fileType === "audio" ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#6B7280",
            }}
          >
            <AudioIcon sx={{ fontSize: { xs: 24, sm: 32 }, mb: 1 }} />
            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                fontSize: { xs: "0.65rem", sm: "0.7rem" },
              }}
            >
              {file.name.length > 15
                ? file.name.substring(0, 15) + "..."
                : file.name}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#6B7280",
            }}
          >
            <DocumentIcon
              sx={{ fontSize: { xs: 24, sm: 32 }, mb: 1 }}
            />
            <Typography
              variant="caption"
              sx={{
                textAlign: "center",
                fontSize: { xs: "0.65rem", sm: "0.7rem" },
              }}
            >
              {file.name.length > 15
                ? file.name.substring(0, 15) + "..."
                : file.name}
            </Typography>
          </Box>
        )}

        <IconButton
          size="small"
          onClick={() => onRemoveFile(index)}
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.9)",
            },
            width: { xs: 20, sm: 24 },
            height: { xs: 20, sm: 24 },
          }}
        >
          <CloseIcon sx={{ fontSize: { xs: 12, sm: 14 } }} />
        </IconButton>

        <Box
          sx={{
            position: "absolute",
            bottom: 4,
            left: 4,
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            padding: { xs: "1px 4px", sm: "2px 6px" },
            borderRadius: 1,
            fontSize: { xs: "0.55rem", sm: "0.6rem" },
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          {fileType}
        </Box>
      </Box>

      {/* file name */}
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mt: 0.5,
          fontSize: { xs: "0.65rem", sm: "0.7rem" },
          color: "text.secondary",
          textAlign: "center",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {file.name.length > 20
          ? file.name.substring(0, 20) + "..."
          : file.name}
      </Typography>
    </Box>
  );
});

export default FilePreviewItem;
